"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubPartInvestissementsDurablesCorporation = void 0;
exports.ESubPartInvestissementsDurablesCorporation = {
    between_0_25: "between_0_25",
    between_26_50: "between_26_50",
    between_51_75: "between_51_75",
    between_76_100: "between_76_100",
};
